<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-container modal-small">
      <button class="modal-close" @click="$emit('close')">X</button>

      <div class="modal-body">
        <h2 class="modal-title">{{ $t('health.nutritionalPlanTemplate.create') }}</h2>

        <div class="form-group">
          <label for="templateName" class="form-label">{{ $t('health.patient.name') }} <span class="required">*</span></label>
          <input
            id="templateName"
            type="text"
            v-model="name"
            class="form-control"
            maxlength="255"
          />
        </div>

        <div class="form-group">
          <label for="templateDesc" class="form-label">{{ $t('health.nutritionalPlanTemplate.description') }}</label>
          <textarea
            id="templateDesc"
            v-model="description"
            class="form-control"
            rows="4"
            maxlength="500"
          ></textarea>
        </div>

        <div class="modal-actions">
          <button class="cancel-btn" @click="$emit('close')">
            {{ $t('health.NutritionistNotes.cancel')}}
          </button>
          <button class="save-btn" :disabled="!name.trim()" @click="onSave">
            {{ $t('health.nutritionalPlanTemplate.saveTemplate') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreateTemplateModal',
  data() {
    return {
      name: '',
      description: ''
    }
  },
  methods: {
    onSave() {
      if (!this.name.trim()) return;
      this.$emit('save', {
        name: this.name.trim(),
        description: this.description.trim()
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../stylesheets/variables";

$accent: #F35647;

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(#000, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-small {
  width: 100%;
  max-width: 450px;
  background: #fff;
  border-radius: $radius;
  padding: 2em;
  position: relative;
}

.modal-close {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 1.2em;
  cursor: pointer;
  color: $black-light6;
}

.modal-title {
  margin-top: 0;
  margin-bottom: 1.5em;
  color: $accent;
}

.form-group {
  margin-bottom: 1.5em;
}

.form-label {
  display: block;
  font-weight: 600;
  margin-bottom: 0.5em;
  font-size: 0.9em;

  .required {
    color: $accent;
  }
}

.form-control {
  width: 100%;
  padding: 0.75em;
  border: 1px solid rgba($black, 0.2);
  border-radius: $radius;
  font-family: inherit;

  &:focus {
    outline: none;
    border-color: $accent;
  }
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1em;
  margin-top: 2em;
}

.cancel-btn {
  background: transparent;
  border: 1px solid rgba($black, 0.2);
  padding: 0.5em 1.5em;
  border-radius: $radius;
  cursor: pointer;

  &:hover {
    background: rgba($black, 0.05);
  }
}

.save-btn {
  background: $accent;
  color: #fff;
  border: none;
  padding: 0.5em 1.5em;
  border-radius: $radius;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    background: darken($accent, 10%);
  }
}
</style>



// WEBPACK FOOTER //
// src/brand/health/components/template/CreateTemplateModal.vue